import { useMutation } from "util/graphql";

import TagUserMutation from "./tag_user_mutation.graphql";

export function useTagUserMutation() {
  return useMutation(TagUserMutation);
}
